export class Filter {
  name?: string | string[];
  state?: string;
  docref?: string;
}

export class AvailabilityFilter extends Filter {
  _key?: string;
  start?: Date;
  end?: Date;
}

export class AvailabilityFilterDetailed extends Filter {
  start?: string;
  end?: string;
  name?: string;
  service: string[];
  status: string[];
  campus: string[];
  space: string[];
  responsable: string[];
  dateStart?: number;
  dateEnd?: number;
  filterDate?: string;

  constructor() {
    super();
    this.service = [];
    this.status = [];
    this.campus = [];
    this.space = [];
    this.responsable = [];
    this.name = "";
    this.state = "";
  }

  static isEmpty(data: AvailabilityFilterDetailed): boolean {
    return (
      (data.name === undefined || data.name.length === 0) &&
      (data.service === undefined || data.service.length === 0) &&
      (data.status === undefined || data.status.length === 0) &&
      (data.campus === undefined || data.campus.length === 0) &&
      (data.space === undefined || data.space.length === 0) &&
      (data.responsable === undefined || data.responsable.length === 0) &&
      (data.dateStart === undefined || data.dateStart === 0) &&
      (data.dateEnd === undefined || data.dateEnd === 0)
    );
  }

  static hasMultiFilters(data: AvailabilityFilterDetailed): boolean {
    return (
      data.service?.length > 1 ||
      data.status?.length > 1 ||
      data.campus?.length > 1 ||
      data.space?.length > 1 ||
      data.responsable?.length > 1
    );
  }
}
